var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"fleet-task-instant-create"},[_c('MinimizeCreateSection'),_c('MapLiveview')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }